/* eslint-disable */
import React from "react";
import { FormControl, FormLabel, Select } from "@chakra-ui/react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Paper,
  Switch,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Skeleton } from "@material-ui/lab";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
// core components
import {
  editUser,
  getAllProperties,
  getAuthorizationValues,
  getUser,
  getUserRoles,
  updateUser,
  updateUsersRole,
} from "../../utils/store/actions/users.actions";
import { withTranslation } from "react-i18next";
import { B4FRadio } from "../../components/component-questionnaire/B4FFields/B4FRadio";
import { SubRole } from "../../entities/enums/SubRole";
import { sortAlphabetically } from "../../utils/entities/translation/translation.service";

const styles = (theme: Theme) =>
  createStyles({
    paper: {
      backgroundColor: "transparent",
      maxWidth: "90%",
      margin: "auto",
      marginTop: "5%",
      boxShadow: "none",
    },
    searchBar: {
      backgroundColor: "#F5F6FF",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
    searchInput: {
      backgroundColor: "#F5F6FF",
      fontSize: theme.typography.fontSize,
    },
    block: {
      display: "block",
    },
    addUser: {
      marginRight: theme.spacing(1),
    },
    contentWrapper: {
      margin: "40px 16px",
    },
  });

export const SALES_ROLES = ["SALES"];
export const autoFillUser = (user: any) => {
  const internal = (user.internal?.toString() === "true");
  if (!SALES_ROLES.includes(user.role) || internal) {
    return {
      ...user,
      subRole: undefined,
    };
  }

  if (!user.subRole) {
    return {
      ...user,
      subRole: SubRole.DISTRIBUTOR
    };
  }
  return user;
};

class User extends React.PureComponent<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      userName: null,
      firstName: null,
      role: null,
      subRole: null,
      email: null,
      language: null,
      contact: null,
      about: null,
    };
  }

  remove_duplicates_es6 = (arr: any) => {
    let s = new Set(arr);
    let it = s.values();
    return Array.from(it);
  };

  async componentWillMount() {
    const userId = new URLSearchParams(window.location.search).get("id");
    await this.props.getAllProperties();
    await this.props.getUser(userId);
    await this.props.getUserRoles(userId);
    await this.props.getAuthorizationValues();
  }

  getSections = (role: any) => {
    const keys: any = [];
    Object.keys(role).map((key) => {
      let match = key.match(/^(?:[^A-Z]+)/g);
      match && match[0] !== "role" && match[0] !== "id" && keys.push(match[0]);
    });
    return this.remove_duplicates_es6(keys);
  };

  buildSections = (role: any, sections: any) => {
    const keys: any = {};
    sections.map((sec: any) => {
      keys[sec] = [];
      Object.keys(role).map((key) => {
        let match = key.match(/^(?:[^A-Z]+)/g);
        match &&
          match[0] === sec &&
          (keys[sec] = [...keys[sec], { key: key, label: role[key] }]);
      });
    });
    return keys;
  };

  editUser = (user: any) => {
    this.props.editUser(autoFillUser(user));
  };
  handleChange = (e: any) => {
    const id = e.target.id;
    const value = e.target.value;
    const currentUser = this.props.Users.user;
    const role = id === "role" ? value : currentUser.role;
    const internal = id === "internal" ? value : currentUser.internal;
    this.props.updateUser(
      id,
      value,
      autoFillUser({
        ...currentUser,
        role,
        internal,
      })
    );
  };
  handleChangeRole = (role: any, e: any) => {
    this.props.updateUsersRole(
      this.props.Users.user.id,
      role,
      [e.target.name],
      e.target.value || e.target.checked
    );
    this.setState({ ...this.state, [e.target.name]: e.target.checked });
  };

  render() {
    const { user } = this.props.Users;
    const { classes, Users, t } = this.props;
    const { role, get_properties, authValues } = Users;
    let sections: any = [];
    let sectionsContent: any = [];
    let userRightOptions: Array<string> = [];
    let userRoleOptions: Array<string>;
    let userSubRoleOptions: Array<string> = [
      SubRole.INITIATOR,
      SubRole.DISTRIBUTOR,
    ];

    if (role) {
      sections = this.getSections(role);
      sectionsContent = this.buildSections(role, sections);
    }

    //call for get
    if (
      get_properties &&
      get_properties.find(
        (property: { key: string; value: boolean }) =>
          property.key === "IS_V4_AVAILABLE"
      ).value === "true" &&
      authValues
    ) {
      userRightOptions = authValues;
      userRoleOptions = ["SALES", "OPERATOR", "DEPOSITARY"];
    } else {
      userRightOptions = [
        "NONE",
        "OWNER_AND_ASSIGNEE_IS_ME",
        "ASSIGNEE_IS_ME",
        "OWNER_IS_ME",
        "OWNER_IS_IN_MY_GROUP",
        "INVESTOR",
        "OPERATION_IS_IN_MY_FOUND",
        "ALL",
      ];
      if (this.props.LocalUser.me.role === "SUPERVISOR") {
        userRoleOptions = [
          "SALES",
          "ANALYST",
          "MANAGER",
          "ADMINISTRATOR",
          "DEPOSITARY",
          "SUPERVISOR",
        ];
      } else {
        userRoleOptions = [
          "SALES",
          "ANALYST",
          "MANAGER",
          "ADMINISTRATOR",
          "DEPOSITARY",
        ];
      }
    }
    return (
      <>
        {/* Page content */}
        {user.id !== "" ? (
          <Paper className={classes.paper}>
            <Row style={{ backgroundColor: "transparent" }}>
              <Col
                className="order-xl-2 mb-5 mb-xl-0"
                xl="4"
                style={{ backgroundColor: "transparent" }}
              >
                <Card className="card-profile shadow">
                  <Row className="justify-content-center">
                    <Col className="order-lg-6" lg="12">
                      <div className="card-profile-image">
                        <a
                          href="#pablo"
                          onClick={(e) => e.preventDefault()}
                        ></a>
                      </div>
                    </Col>
                  </Row>
                  <CardHeader className="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                    <div
                      className="d-flex justify-content-center"
                      style={{ color: "#ae0064" }}
                    >
                      {t("USER_RIGHTS")}
                    </div>
                  </CardHeader>
                  <CardBody className="pt-0 pt-md-4">
                    {sections !== [] &&
                      sections.map((sec: any) => (
                        <Accordion key={sec}>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography className={classes.heading}>
                              {t(sec.toLowerCase())}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Row className="align-items-center">
                              {sectionsContent[sec].map((content: any) => {
                                return (
                                  <Col
                                    key={content.key}
                                    className="order-xl-2 mb-5 mb-xl-0"
                                    xl="4"
                                  >
                                    <FormControl>
                                      <FormLabel>{t(content.key)}</FormLabel>
                                      {typeof content.label === "boolean" ? (
                                        <Switch
                                          checked={content.label}
                                          onChange={(e: any) =>
                                            this.handleChangeRole(role, e)
                                          }
                                          color="primary"
                                          name={content.key}
                                          inputProps={{
                                            "aria-label": "primary checkbox",
                                          }}
                                        />
                                      ) : (
                                        <Select
                                          bg="white"
                                          name={content.key}
                                          value={content.label}
                                          onChange={(e: any) => {
                                            this.handleChangeRole(role, e);
                                          }}
                                        >
                                          {userRightOptions &&
                                            userRightOptions.map((option) => (
                                              <option value={option}>
                                                {t(option)}
                                              </option>
                                            ))}
                                        </Select>
                                      )}
                                    </FormControl>
                                  </Col>
                                );
                              })}
                            </Row>
                          </AccordionDetails>
                        </Accordion>
                      ))}
                  </CardBody>
                </Card>
              </Col>
              {/* CENTER CONTENT */}
              <Col className="order-xl-1" xl="8">
                <Card className="bg-secondary shadow">
                  <CardHeader className="bg-white border-0">
                    <Row className="align-items-center">
                      <Col xs="8">
                        <h3 style={{ color: "#ae0064" }} className="mb-0">
                          {user.name}
                        </h3>
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <Form>
                      <h6 className="heading-small text-muted mb-4">
                        {t("USER_INFORMATION")}
                      </h6>
                      <div className="pl-lg-4">
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="name"
                              >
                                {t("NAME")}
                              </label>
                              <Input
                                className="form-control-alternative"
                                defaultValue={user.name}
                                onChange={(e: any) => this.handleChange(e)}
                                id="name"
                                placeholder="name"
                                type="text"
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="firstName"
                              >
                                {t("FIRST_NAME")}
                              </label>
                              <Input
                                className="form-control-alternative"
                                defaultValue={user.firstName}
                                onChange={(e: any) => this.handleChange(e)}
                                id="firstName"
                                placeholder="First name"
                                type="text"
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormControl isRequired>
                              <label
                                className="form-control-label"
                                htmlFor="role"
                              >
                                {t("ROLE")}
                              </label>
                              <Select
                                bg="white"
                                id="role"
                                value={user.role}
                                onChange={(e: any) => this.handleChange(e)}
                              >
                                {userRoleOptions &&
                                  userRoleOptions.map((option) => (
                                    <option value={option}>{t(option)}</option>
                                  ))}
                              </Select>
                            </FormControl>
                          </Col>
                          <Col lg="6">
                            <FormControl isRequired>
                              <label
                                className="form-control-label"
                                htmlFor="canLogin"
                              >
                                {t("canLogin")}
                              </label>
                              <B4FRadio
                                key="canLogin"
                                id="canLogin"
                                onChange={(e: any) => {
                                  this.handleChange(e);
                                }}
                                options={[
                                  { label: "YES_NO.YES", key: "true" },
                                  { label: "YES_NO.NO", key: "false" },
                                ]}
                                value={user.canLogin?.toString()}
                                isRequired={false}
                                visible={true}
                              />
                            </FormControl>
                          </Col>
                          <Col lg="6">
                            <FormControl isRequired>
                              <label
                                className="form-control-label"
                                htmlFor="internal"
                              >
                                {t("INTERNAL")}
                              </label>
                              <B4FRadio
                                key="internal"
                                id="internal"
                                onChange={(e: any) => {
                                  this.handleChange(e);
                                }}
                                options={[
                                  { label: "YES_NO.YES", key: "true" },
                                  { label: "YES_NO.NO", key: "false" },
                                ]}
                                value={user.internal.toString()}
                                isRequired={false}
                                visible={true}
                                // isDisabled={true}
                              />
                            </FormControl>
                          </Col>
                          {user.internal?.toString() === "false" &&
                            SALES_ROLES.includes(user.role) && (
                              <Col lg="6">
                                <FormControl>
                                  <label
                                    className="form-control-label"
                                    htmlFor="subRole"
                                  >
                                    {t("SUB_ROLE")}
                                  </label>
                                  <Select
                                    bg="white"
                                    id="subRole"
                                    value={user.subRole}
                                    onChange={(e: any) => this.handleChange(e)}
                                  >
                                    {userSubRoleOptions
                                      ?.sort((a, b) =>
                                        sortAlphabetically(a, b, t)
                                      )
                                      .map((option) => (
                                        <option value={option}>
                                          {t(option)}
                                        </option>
                                      ))}
                                  </Select>
                                </FormControl>
                              </Col>
                            )}
                          {user.internal?.toString() === "true" &&
                            user.role === "OPERATOR" && (
                              <Col lg="6">
                                <FormControl isRequired>
                                  <label
                                    className="form-control-label"
                                    htmlFor="canReceiveOngoingScreeningEmail"
                                  >
                                    {t("canReceiveOngoingScreeningEmail")}
                                  </label>
                                  <B4FRadio
                                    key="canReceiveOngoingScreeningEmail"
                                    id="canReceiveOngoingScreeningEmail"
                                    onChange={(e: any) => {
                                      this.handleChange(e);
                                    }}
                                    options={[
                                      { label: "YES_NO.YES", key: "true" },
                                      { label: "YES_NO.NO", key: "false" },
                                    ]}
                                    value={
                                      user.canReceiveOngoingScreeningEmail?.toString() ||
                                      "false"
                                    }
                                    isRequired={false}
                                    visible={true}
                                  />
                                </FormControl>
                              </Col>
                            )}
                        </Row>
                      </div>
                      <hr className="my-4" />
                      {/* Address */}
                      <h6 className="heading-small text-muted mb-4">
                        {t("CONTACT_INFORMATION")}
                      </h6>
                      <div className="pl-lg-4">
                        <Row>
                          <Col lg="12">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="email"
                              >
                                {t("EMAIL")}
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="email"
                                defaultValue={user.email}
                                onChange={(e: any) => this.handleChange(e)}
                                placeholder="Email"
                                type="email"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="4">
                            <FormControl isRequired>
                              <label
                                className="form-control-label"
                                htmlFor="language"
                              >
                                {t("LANGUAGE")}
                              </label>
                              <Select
                                bg="white"
                                id="language"
                                defaultValue={user.language}
                                onChange={(e: any) => this.handleChange(e)}
                              >
                                <option value="en">{t("ENGLISH")}</option>
                                <option value="fr">{t("FRENCH")}</option>
                                <option value="it">{t("ITALIAN")}</option>
                                <option value="es">{t("SPANISH")}</option>
                              </Select>
                            </FormControl>
                          </Col>
                          {user.teams && (
                            <Col lg="8">
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="team"
                                >
                                  {t("TEAMS")}
                                </label>
                                <Select
                                  bg="white"
                                  id="team"
                                  placeholder={t("TEAMS")}
                                >
                                  {user.teams.map((t: any) => (
                                    <option key={t.name}>{t.name}</option>
                                  ))}
                                </Select>
                              </FormGroup>
                            </Col>
                          )}
                        </Row>
                      </div>
                      <Button
                        onClick={(e: any) => {
                          e.preventDefault();
                          this.editUser(user);
                        }}
                        variant="outlined"
                        style={{
                          color: "#ae0064",
                          borderColor: "#ae0064",
                          textTransform: "none",
                        }}
                      >
                        {t("SAVE")}
                      </Button>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Paper>
        ) : (
          <Skeleton variant="rect" width={"100%"} height={"72vh"} />
        )}
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getUser,
  editUser,
  updateUser,
  getUserRoles,
  updateUsersRole,
  getAuthorizationValues,
  getAllProperties,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(User)));
